import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { StatusLabelComponent } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  PRACTICE_SETUP_STEP_STATUS_COLOUR_MAP,
  PracticeSetupStepStatus,
} from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-practice-setup-step-status',
  templateUrl: './practice-setup-step-status.component.html',
  styleUrls: ['./practice-setup-step-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, StatusLabelComponent],
  host: { class: 'flex' },
})
export class PracticeSetupStepStatusComponent {
  dense = input(false, { transform: coerceBooleanProperty });
  status = input.required<PracticeSetupStepStatus>();
  statusColor = computed(
    () => PRACTICE_SETUP_STEP_STATUS_COLOUR_MAP[this.status()]
  );

  statusLabel(status: PracticeSetupStepStatus): string {
    switch (status) {
      case PracticeSetupStepStatus.NotStarted:
        return 'Not Started';
      case PracticeSetupStepStatus.InProgress:
        return 'In Progress';
      case PracticeSetupStepStatus.ValidationFailed:
        return 'Needs Attention';
      case PracticeSetupStepStatus.Complete:
        return 'Complete';
      default:
        return status;
    }
  }
}
